
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

interface ArticleContentProps {
  content: string;
}

export default function ArticleContent({ content }: ArticleContentProps) {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="py-12 bg-white">
      <div
        ref={ref}
        className={`max-w-3xl mx-auto px-6 lg:px-8 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <article
          className="prose prose-lg prose-slate max-w-none
            prose-headings:font-['Montserrat'] prose-headings:font-bold prose-headings:text-slate-800
            prose-h2:text-2xl prose-h2:mt-12 prose-h2:mb-4
            prose-p:text-slate-600 prose-p:leading-relaxed prose-p:mb-6
            prose-strong:text-slate-800 prose-strong:font-semibold
            prose-a:text-[#00989e] prose-a:no-underline hover:prose-a:underline
            prose-ul:my-6 prose-li:text-slate-600 prose-li:mb-2
            prose-blockquote:border-l-4 prose-blockquote:border-[#00989e] prose-blockquote:bg-slate-50 prose-blockquote:py-4 prose-blockquote:px-6 prose-blockquote:rounded-r-lg prose-blockquote:not-italic"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </section>
  );
}
